import { action, makeAutoObservable, observable } from "mobx";
import { observer } from "mobx-react-lite";

class ConfigStore {
  baseUrl = "https://consent-api.dev.addinn-group.com/v2";
  clientId = "consent-bb-api";
  appVersion = "v2023.11.6";

  constructor() {
    makeAutoObservable(this);
  }

  setBaseUrl(baseUrl: any) {
    this.baseUrl = baseUrl;
  }

  setClientId(clientId: any) {
    this.clientId = clientId;
  }

  setAppVersion(appVersion: any) {
    this.appVersion = appVersion;
  }

  get BaseUrl() {
    return this.baseUrl;
  }

  get ClientId() {
    return this.clientId;
  }

  get AppVersion() {
    return this.appVersion;
  }
}

export const configStore = new ConfigStore();
